<template>
    <div>
        <v-row class="full-width-row" no-gutters>
            <v-col cols="12" sm="12" md="12">
                <div class="cloud-file-list-box">
                    <div class="cloud-items-container">

                        <div v-if="!groupedAttachments.length" class="cfl-placeholder" >{{ $t('Нет_файлов') }}</div>

                        <v-row 
                            v-else
                            dense
                        >
                            <v-attachment-item
                                v-for="attachment in groupedAttachments[0][1]"
                                :key="attachment.id"
                                :attachment="attachment"
                                :onLoadAttachmet="loadAttachment"
                                :onAttachmentInfo="openInfoModal"
                                :isDeleteable="false"
                                colWidth="4"
                            />
                        </v-row>

                    </div>
                </div>
            </v-col>
        </v-row>

        <FileInfoDlg ref="FileInfoDlgRef" />

    </div>
</template>

<script>
import FileInfoDlg from '@/components/global/dialogs/FileInfoDlg';

export default {
    name: "MeetingDetailPanelAttachments",
    components: {
        FileInfoDlg      
    },
    props: {
        meeting: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        groupedAttachments() {
            let groupedAttachments = this.$_.groupBy(this.meeting.AttachmentsSource, (item) => {
                return item.Group;
            });
            
            Object.keys(groupedAttachments).forEach((key) => {            
                groupedAttachments[key] = groupedAttachments[key].map(x => x).sort(function (a, b) { return a.Name.localeCompare(b.Name); });
            });

            return Object.entries(groupedAttachments);
        },
    },
    methods: {
        async loadAttachment(item) {
            this.$eventBus.$emit('on-download-file', { id: item.Id, name: item.Name, passedType: 'plannedmeetingattachment' });
        },
        async openInfoModal(attachment) {
            try
            {
                await this.$refs.FileInfoDlgRef.open({ ParentType: 'PlannedMeeting', ...attachment });
            }
            catch (ex)
            {
                console.log(ex);
            }
        }
    }
}
</script>